<div class="row">
  <div class="col-12">
    <app-loading-spinner [loadingTitle]="'Please wait, completing connection...'"></app-loading-spinner>
  </div>
</div>
